if (!customElements.get('slider-cards')) {
  class SliderCards extends HTMLElement {
    constructor() {
      super();

      this.slidesPerGroup = parseInt(this.dataset.slidesPerGroup) || 3;

      this.selectors = {
        slider: '[data-slider]',
      };

      this.settings = {
        elements: {
          slider: this.querySelector(this.selectors.slider),
        },
        instances: {
          slider: null,
        },
        options: {
          slider: {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 18,
            navigation: {
              prevEl: this.querySelector('.swiper-arrow--prev'),
              nextEl: this.querySelector('.swiper-arrow--next'),
            },
            pagination: {
              el: this.querySelector('.swiper-pagination'),
              clickable: true,
            },
            breakpoints: {
              990: {
                slidesPerView: 3,
                slidesPerGroup: this.slidesPerGroup,
                spaceBetween: 32
              }
            }
          },
        },
      };

      if (this.dataset.loop === 'true') {
        this.settings.options.slider.loop = true;
        this.settings.options.slider.loopAdditionalSlides = this.slidesPerGroup;
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.settings.instances.slider = new Swiper(
        this.settings.elements.slider,
        this.settings.options.slider,
      );

      this.settings.instances.slider.slidePrev(0);
      this.settings.instances.slider.slideNext(0);
    }
  }

  customElements.define('slider-cards', SliderCards);
}
